import { render, staticRenderFns } from "./BotonesProcesoImpresion.vue?vue&type=template&id=12bc69e7&"
import script from "./BotonesProcesoImpresion.vue?vue&type=script&lang=js&"
export * from "./BotonesProcesoImpresion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports